import moment from "moment";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { ADMINISTRATOR, DIRECTOR, FINTECH } from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";
import { DayPicker, StyledCheckboxInput } from "../../../../common/form";
import { ACTIVE } from "../../enums/clientStatusTypes";

let startDateValidation;

class CoveragePeriod extends React.Component {
  constructor(props) {
    super(props);
    this.showButton = this.showButton.bind(this);
  }
  showButton(event) {
    const changeFieldValue = this.props.changeFieldValue;
    if (event.target.checked) {
      const minimumStartDate = moment(this.props.initialValues.coveragePeriod.endDate, "YYYY-MM-DD").add(1, 'days');
      startDateValidation = (current) => current.isAfter(minimumStartDate);
      changeFieldValue(
        "client",
        "coveragePeriod.startDate",
        minimumStartDate
      );
      changeFieldValue("client", "coveragePeriod.endDate", "");
    } else {
      startDateValidation = undefined;
      changeFieldValue(
        "client",
        "coveragePeriod.startDate",
        this.props.initialValues.coveragePeriod.startDate
      );
      changeFieldValue(
        "client",
        "coveragePeriod.endDate",
        this.props.initialValues.coveragePeriod.endDate
      );
    }
  }
  render() {
    const { disabled, create, clientStatusType, isInactivationPlanned } = this.props;
    const canRenewPeriod = !create && clientStatusType == ACTIVE.value && !isInactivationPlanned;

    return (
      <div className="ClientSubsection">
        <h3>
          <FormattedMessage id="clients.form.coveragePeriods.title" />
        </h3>
        <Field
          id="coveragePeriod.startDate"
          name="coveragePeriod.startDate"
          component={DayPicker}
          required={true}
          disabled={disabled}
          label={
            <FormattedMessage id="clients.form.coveragePeriods.startDate" />
          }
          props={{
            isValidDate: startDateValidation,
          }}
        />
        <Field
          id="coveragePeriod.endDate"
          name="coveragePeriod.endDate"
          component={DayPicker}
          required={true}
          disabled={disabled}
          label={<FormattedMessage id="clients.form.coveragePeriods.endDate" />}
          props={{
            isValidDate: startDateValidation,
          }}
        />

        {userHasAccess([ADMINISTRATOR, FINTECH, DIRECTOR], true) && canRenewPeriod && (
          <Field
            id="isRenewal"
            name="isRenewal"
            type="checkbox"
            component={StyledCheckboxInput}
            disabled={disabled}
            checkbox={{ value: true }}
            props={{ onChange: this.showButton }}
            label={
              <FormattedMessage id="clients.form.coveragePeriods.renewCoverage" />
            }
            normalize={(value) => !!value}
          />
        )}
      </div>
    );
  }
}
CoveragePeriod.propTypes = {
  disabled: PropTypes.bool,
  initialValues: PropTypes.object,
  create: PropTypes.bool,
  changeFieldValue: PropTypes.func,
  clientStatusType: PropTypes.string,
  isInactivationPlanned: PropTypes.bool,
};

export default CoveragePeriod;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/CoveragePeriod.js